import { render, staticRenderFns } from "./UninstallSurvey.vue?vue&type=template&id=2f21d1bc&"
import script from "./UninstallSurvey.vue?vue&type=script&lang=js&"
export * from "./UninstallSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports